import * as React from "react";
import { z } from "zod";
import styled from "styled-components";
import { Blade } from "../../../components/Blade";
import { mixinSkins } from "../../../skins/shared/mixins/themeStyles";
import { SkinId } from "../../../skins/types";
import { riotProductSkin } from "../skins/riot-product";
import { ContentListBladeSchema } from "../../../schemas/blades/ContentList";
import { BladeContent } from "../../../components/BladeContent";
import { ArticleFeaturedCard } from "../../../molecules/ArticleFeaturedCard";
import { useState } from "react";
import { Icon } from "../../../components/Icon";
import { BladeHeaderDefault } from "../../../molecules/BladeHeaderDefault";
export const ArticleCardGridContractSchema = ContentListBladeSchema.extend({
    type: z.literal("articleCardGrid"),
});
export const Grid = styled.div ``;
const batchSize = 12;
const _ArticleCardGrid = ({ backdrop, header, items, ...props }) => {
    const [visibleItemsCount, setVisibleItemsCount] = useState(batchSize);
    const handleShowMore = () => {
        setVisibleItemsCount((prevVisibleItems) => prevVisibleItems + batchSize);
    };
    const isShowMoreVisible = visibleItemsCount < items.length;
    return (React.createElement(Blade, { "data-testid": "article-card-grid", ...props },
        React.createElement(BladeContent, { width: "large" },
            React.createElement(BladeHeaderDefault, { ...header }),
            React.createElement(Grid, null, items.slice(0, visibleItemsCount).map((item, index) => (React.createElement(ArticleFeaturedCard, { content: item, key: index })))),
            isShowMoreVisible && (React.createElement("div", { className: "show-more" },
                React.createElement("div", { className: "divider" }),
                React.createElement("div", { className: "button-container" },
                    React.createElement("button", { className: "cta", onClick: handleShowMore },
                        React.createElement("span", null, props.pager?.more.text || "show more"),
                        React.createElement(Icon, { name: "plus" }))))))));
};
export const ArticleCardGrid = styled(_ArticleCardGrid) `
  ${mixinSkins({
    [SkinId.RiotProduct]: riotProductSkin,
})}
`;
//# sourceMappingURL=ArticleCardGrid.js.map